import React from "react";
import Select from "react-select";

import { useTranslation } from "react-i18next";
import { pageRootTestIds } from "../../testing/pageRootTestIds";

const SelectTemplateStep = ({
  templateOptions,
  selectedOption,
  onSelectTemplate,
  loadingTemplates,
  templateName,
  onTemplateNameChange,
  templateNameError,
  emailSubject,
  onEmailSubjectChange,
  emailSubjectError,
  selectedTemplate,
  onBack,
  onContinue,
  isContinuing,
  previewHtml,
  previewLoading,
}) => {
  const { t } = useTranslation();
  return (
    <div className="px-20 py-10 " id={pageRootTestIds.cloneEmailSelectStep}>
      <div className="grid grid-cols-1 xl:grid-cols-2 gap-6 bg-cfSecondary border border-cfIssuedScreenSearchBorder rounded-xl p-5 shadow-lg">
        <div className="space-y-5 xl:border-r xl:pr-6 border-gray-200 ">
          <div>
            <p className="text-xl leading-tight font-semibold text-cfHeadingText">
              {t("settings:clone_email_template")}
            </p>
          </div>
          <div>
            <label
              htmlFor="clone-template-select"
              className="text-sm font-medium text-gray-900"
            >
              {t("settings:email_template")}
            </label>
            <Select
              options={templateOptions}
              value={selectedOption || null}
              onChange={(option) => onSelectTemplate(option?.template || null)}
              isLoading={loadingTemplates}
              isSearchable
              placeholder={t("settings:search_template")}
              className="text-sm"
            />
            <p className="text-xs text-cfGlobalText mt-2">
              {t("settings:email_dropdown_description")}
            </p>
          </div>
          <div>
            <label
              htmlFor="clone-template-name"
              className="text-sm font-medium text-gray-900 after:content-['*'] after:text-red-500 "
            >
              {t("settings:template_name")}
            </label>
            <div className="relative">
              <input
                id="clone-template-name"
                type="text"
                value={templateName}
                onChange={(event) => onTemplateNameChange(event.target.value)}
                className={`rounded-lg w-full h-12 focus:outline-none border text-base text-cfSignInSignUpInputPlaceholderText ${
                  templateNameError
                    ? "border-red-500"
                    : "border-cfSignInSignUpInputBorder"
                }`}
                placeholder={t("settings:template_name_placeholder")}
              />
            </div>
            {templateNameError ? (
              <p className="mt-1 text-sm text-red-600">{templateNameError}</p>
            ) : null}
          </div>
          <div>
            <label
              htmlFor="clone-template-subject"
              className="text-sm font-medium text-gray-900 after:content-['*'] after:text-red-500"
            >
              {t("settings:email_subject")}
            </label>
            <input
              id="clone-template-subject"
              type="text"
              value={emailSubject}
              onChange={(event) => onEmailSubjectChange(event.target.value)}
              className={`rounded-lg w-full h-12 focus:outline-none border text-base text-cfSignInSignUpInputPlaceholderText ${
                emailSubjectError
                  ? "border-red-500"
                  : "border-cfSignInSignUpInputBorder"
              }`}
              placeholder={t("settings:email_subject_placeholder")}
            />
            {emailSubjectError ? (
              <p className="mt-1 text-sm text-red-600">{emailSubjectError}</p>
            ) : null}
          </div>
          <div className="pt-4 border-t border-gray-200 flex items-center justify-between mt-4">
            <button
              type="button"
              id="clone-email-select-step-cancel"
              onClick={onBack}
              className="flex items-center justify-center px-5 py-2 w-36 text-sm active:text-gray-700 capitalize transition-colors duration-200 bg-cfSecondary border rounded-md gap-x-2 hover:bg-gray-100 disabled:text-gray-400"
            >
              {t("settings:cancel")}
            </button>
            <button
              type="button"
              id="clone-email-select-step-continue"
              onClick={onContinue}
              disabled={isContinuing || !selectedTemplate}
              className="flex items-center justify-center px-5 py-2 w-36 text-sm text-cfSecondary capitalize transition-colors duration-200 bg-cfPrimary border rounded-md gap-x-2 hover:bg-cfPrimaryDark disabled:cursor-not-allowed disabled:opacity-60 font-semibold"
            >
              {isContinuing ? t("settings:processing") : t("settings:continue")}
            </button>
          </div>
        </div>
        <div>
          <p className="text-xl leading-tight font-semibold text-cfHeadingText">
            {t("settings:template_preview")}
          </p>
          <p className="text-cfGlobalText mt-2 mb-3">
            {selectedTemplate?.template_name || t("settings:select_preview")}
          </p>
          <div className="rounded-xl border border-cfIssuedScreenSearchBorder overflow-hidden bg-[#F4F7FB] min-h-[680px]">
            {loadingTemplates || previewLoading ? (
              <div className="h-[680px] flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              </div>
            ) : previewHtml ? (
              <iframe
                title="template-preview"
                srcDoc={`${previewHtml}<style>a,button,input,select,textarea,[role="button"],[onclick]{pointer-events:none!important;cursor:default!important;}</style>`}
                sandbox=""
                referrerPolicy="no-referrer"
                className="w-full h-[680px] bg-white"
              />
            ) : (
              <div className="h-[680px] flex items-center justify-center text-cfGlobalText">
                {t("settings:no_preview")}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectTemplateStep;
